module.exports = __webpack_public_path__ + "img/hgMainLogoTitle.af5b3cae.svg";